import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import axios from 'axios';
import store from './store';
import App from './App';
import tenant from './config/tenant';
import './styles/index.css';
import { ConfirmProvider } from './utils/ConfirmContext';
import { handleUnauthorized, isUnauthorizedPayload } from './utils/authUtils';

axios.defaults.baseURL = tenant.api.baseUrl.endsWith('/')
  ? tenant.api.baseUrl
  : `${tenant.api.baseUrl}/`;

axios.interceptors.request.use(
  (config) => {
    const token = 
      localStorage.getItem('AuthKey') || 
      localStorage.getItem('auth-key') || 
      localStorage.getItem('auth_key') || 
      localStorage.getItem('token') || 
      localStorage.getItem('Authkey');
    if (token) {
      config.headers['auth-key'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (isUnauthorizedPayload(response?.data, response?.status)) {
      handleUnauthorized();
    }
    return response;
  },
  (error) => {
    if (isUnauthorizedPayload(error.response?.data, error.response?.status)) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401 || response.status === 403) {
    handleUnauthorized();
  } else {
    try {
      const clone = response.clone();
      clone.json().then((data) => {
        if (isUnauthorizedPayload(data, response.status)) {
          handleUnauthorized();
        }
      }).catch(() => {});
    } catch (e) {
      // ignore
    }
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
  </Provider>
);
